import createClient from 'openapi-fetch';

import { getPreviousUrl } from './previousUrl';
import type { paths } from './types/generated';
import { plenaryIdentity } from './utils/plenaryIdentity';
import { PLENARY_CONTEXT_ID_HEADER } from '../common/consts/plenaryIdHeader';
import { getEnvVar } from '../utils/getEnvVar';

const EXPRESS_API_BASE_URL = getEnvVar('VITE_EXPRESS_API_URL');

export const baseUrl = `${EXPRESS_API_BASE_URL}/api`;

export const apiClient = createClient<paths>({
  baseUrl,
  credentials: 'include', // always send cookies
  headers: { 'Content-Type': 'application/json' }
});

apiClient.use({
  onRequest({ request }) {
    if (typeof window !== 'undefined') {
      request.headers.set('X-Client-URL', window.location.href);
      const previousUrl = getPreviousUrl();
      if (previousUrl) {
        request.headers.set('X-Client-Referrer', previousUrl);
      }
    }
    if (plenaryIdentity.contextId) {
      request.headers.set(PLENARY_CONTEXT_ID_HEADER, plenaryIdentity.contextId);
    }
    return request;
  }
});

export async function apiCall<T>(
  promise: Promise<{ data?: T | undefined; error?: unknown; response: Response }>
): Promise<T> {
  const { data, error, response } = await promise;
  if (!response.ok) {
    throw error ?? new Error(`HTTP ${response.status}`);
  }
  return data as T;
}
